import "./Buttons.css";
import { styled } from "styled-components";

export const StyledDefaultButton = styled.button.attrs(() => ({
  className: "custom-button default-button",
}))``;

export const MenuItemButton = styled.button.attrs(() => ({
  className: "default-button menu-item",
}))``;

export const StyledPrimaryButton = styled.button.attrs(() => ({
  className: "custom-button primary-button",
}))``;

export const StyledScrollButton = styled(StyledDefaultButton)<{
  height?: string;
}>`
  height: ${({ height = "50px" }) => height};
  width: auto;
  margin: 0px;
`;

export const StyledPrimaryRightMarginButton = styled(StyledPrimaryButton)`
  margin: 0px 20px 0px auto;
`;

export const StyledIconDefaultButton = styled(StyledDefaultButton)<{
  height?: string;
  width?: string;
  margin?: string;
  padding?: string;
  $with_shadow?: boolean;
  $with_border?: boolean;
  $bg?: string;
}>`
  height: ${({ height = "40px" }) => height};
  width: ${({ width = "40px" }) => width};
  margin: ${({ margin = "5px" }) => margin};
  padding: ${({ padding = "5px" }) => padding};
  border: ${({ $with_border = false }) =>
    $with_border ? "1px solid #1a6a7c" : "none"};
  ${({ $with_shadow = true }) => {
    return $with_shadow ? "" : "box-shadow: none;";
  }}
  background-color: ${({ $bg = "white" }) => $bg};
  display: flex;

  img {
    height: 90%;
    margin: auto;
  }
`;
